import {
  Button,
  Card,
  CardContent,
  Divider,
  IconButton,
  List,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from 'react-router-dom';

import { ChannelRow } from './channel-row.component';

import { Channel } from '@/services/hsm-backend';

export interface ChannelsCardProps {
  companyId: string;
  channels: Channel[];
}

/**
 * "Canales & líneas HSM" card (read-only, Empresa tab). Lists every channel
 * of the company with its provider avatar/chip and HSM line status chip.
 * The header CTA navigates to the dedicated "Alta de línea" screen, which is
 * where lines are actually provisioned.
 *
 * Data comes from `company.channels` (mapped from the backend `websites[]`
 * in `get-company.ts`).
 */
export const ChannelsCard = ({ companyId, channels }: ChannelsCardProps) => {
  const navigate = useNavigate();

  return (
    <Card>
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6">Canales &amp; líneas HSM</Typography>
          <Button
            variant="outlined"
            size="small"
            onClick={() => navigate(`/company/${companyId}/channel-onboarding`)}
          >
            + Alta de línea
          </Button>
        </Stack>
        <Divider sx={{ mt: 1, mb: 2 }} />
        {channels.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            La empresa no tiene canales.
          </Typography>
        ) : (
          <List disablePadding>
            {channels.map((channel) => (
              <ChannelRow
                key={channel.channelId}
                channel={channel}
                action={
                  <Tooltip title="Gestionar en Alta de línea">
                    <IconButton
                      size="small"
                      aria-label="Ir a alta de línea"
                      onClick={() =>
                        navigate(`/company/${companyId}/channel-onboarding`)
                      }
                    >
                      <OpenInNewIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                }
              />
            ))}
          </List>
        )}
      </CardContent>
    </Card>
  );
};
